import React, { FC } from 'react'
import { useAdriverPixel } from 'Pages/landings/newLandings/common/hooks'
import { LandingNames } from 'Pages/landings/newLandings/common/constants'
import bannerMobileWebp from './bannerMobile.webp'
import bannerMobileJpg from './bannerMobile.jpg'
import banner from './banner.jpg'
import { Banner } from './styled'

export const BannerComponent: FC = () => {
	const containerRef = useAdriverPixel(LandingNames.ACQUIRING)
	return (
		<div ref={containerRef}>
			<Banner
				bannerMobileWebp={bannerMobileWebp}
				bannerMobileJpg={bannerMobileJpg}
				srcBanner={banner}
				subTitle="Установим промотариф на торговый эквайринг при подключении услуги в интернет-банке СберБизнес"
				buttonScrollTo="form"
			>
				Торговый эквайринг
				<br />
				для бизнеса
			</Banner>
		</div>
	)
}
